export const styles = theme => {
  return {
    arrayText: {
      color: '#5c6bc0'
    }
  };
};
